import * as Types from './types'
export const HELP_DICTIONARY: Types.Dictionary = {
  'banner-upload-help': {
    description: 'Recommended dimensions are 550px wide and 150px tall.',
    fontSize: 'icon-12',
  },
  'cutoff-offset': {
    description: 'The amount of minutes before your newsletter send time to stop including new content. ' +
     'Enter an amount in minutes. The default value for this is 90 minutes.' +
      ' (For example, if you send your email at 10am ' +
      'and you want to begin your review window at 4pm the night before, enter 1080)' ,
  },
  'date-filter-help': {
    description: 'Select a date to filter content.',
  },
  'import-csv-help': {
    description: 'If exporting csv from Excel be sure to save as type "CSV UTF-8(Comma delimited)"',
  },
  'lead-post-description': {
    description: 'Provide an alternate description for the article, which will be used in lieu ' +
                 'of whatever description is provided by the article publisher.',
  },
  'lead-post-rank': {
    description: 'Select a rank for the article',
  },
  'lead-post-site-name': {
    description: 'Provide a name for the source of this article.  If a site-name is not found within ' +
                 'the HTML article, this name will be used instead.',
  },
  'lead-post-title': {
    description: 'Provide an alternate title for the article, which will be used in lieu ' +
                 'of whatever title is provided by the article publisher.',
  },
  'lead-post-url': {
    description: 'Enter a URL for the post, such as http://www.example.com/path/to/your/content',
  },
  'member-details-recent_activity': {
    description: 'Detailed opens and clicks within the last week',
  },
  'member-details-time_of_day_activity': {
    description: 'All opens and clicks within the last month',
  },
  'newsbrief-counts-max_lead_count': {
    description: 'Maximum number of lead source pieces to include',
  },
  'newsbrief-counts-max_lead_count_job': {
    description: 'Maximum number of lead job postings to include',
  },
  'newsbrief-counts-max_per_source': {
    description: 'Maximum number of articles per source (only used for sources that do not have a specific ' +
                 'maximum value)',
  },
  'newsbrief-counts-max_per_source_job': {
    description: 'Maximum number of Job postings per source (only used for sources that do not have a specific ' +
                 'maximum value)',
  },
  'newsbrief-counts-max_preferred_count': {
    description: 'Maximum number of preferred source pieces to include',
  },
  'newsbrief-counts-max_preferred_count_job': {
    description: 'Maximum number of preferred job postings to include',
  },
  'newsbrief-counts-minimum_newsbrief_count': {
    description: 'Minimum number of articles required for a newsbrief to be sent',
  },
  'newsbrief-counts-minimum_newsbrief_count_job': {
    description: 'Minimum number of job postings required for a newsbrief to be sent',
  },
  'newsbrief-counts-newsbrief_count': {
    description: 'Maximum number of articles to include in a newsbrief',
  },
  'newsbrief-counts-newsbrief_count_job': {
    description: 'Maximum number of Job postings to include in a newsbrief',
  },
  'promotion-date-parameter': {
    description: 'Query parameter name that identifies message date.',
  },
  'promotion-email-parameter': {
    description: 'Query parameter name that identifies email address.',
  },
  'promotion-emailhash-parameter': {
    description: 'Query parameter name that identifies email address as an MD5.',
  },
  'promotion-person-parameter': {
    description: 'Query parameter name that identifies a person.',
  },
  'promotion-token-parameter': {
    description: 'Query parameter name that identifies a message',
  },
  'search-email': {
    description: 'Restrict to subscribers with an email matching this pattern (gmail.com, for example)',
  },
  'search-modified-date': {
    description: 'Restrict records to those changed since this date',
  },
  'search-schedule': {
    description: 'Restrict subscribers to those that are receiving newsbriefs on the selected schedule',
  },
  'search-segment_1': {
    description: 'Restrict subscribers to those that have this value for their primary segment',
  },
  'search-segment_2': {
    description: 'Restrict subscribers to those that have this value for their secondary segment',
  },
  'search-status': {
    description: 'Restrict to subscribers currently receiving, or not receiving, the newsbrief',
  },
  'security-token': {
    description: 'Enter your security-token for the system you are adding/updating credentials for.',
    fontSize: 'icon-12',
  },
  'send-email': {
    description: 'Enter a valid email address. ' +
    'If you would like to send more than one email please seperate them by commas. ' +
    '(example1@rasa.io, example2@rasa.io)',
  },
  'source-config-category': {
    description: 'Categorization of the content source - Jobs or Content ',
  },
  'source-config-evergreen-date': {
    description: 'If specified, all content published since this date is eligible for all newsbriefs.  If omitted ' +
                 '(the default state), only content published since the last newsbrief will be eligible for ' +
                 'inclusion in the next newsbrief.',
    fontSize: 'icon-12',
  },
  'source-config-excluded-groups': {
    description: 'Exclude tags are terms that, if present in the title, description or tags for a ' +
                 'content piece from this source, will block that piece from any newsbrief.' +
                 'Groups represent common grouping of terms that can be shared across sources.',
  },
  'source-config-excluded-matches': {
    description: 'If there are exclude terms associated with this source, this value defines how many must be ' +
                 'matched to block an article from newsbriefs.  If omitted, matching a single exclude term ' +
                 'will block any post.',
    fontSize: 'icon-12',
  },
  'source-config-excluded-tags': {
    description: 'Exclude tags are terms that, if present in the title, description or tags for a ' +
                'content piece from this source, will block that piece from any newsbrief.',
  },
  'source-config-included-groups': {
    description: 'Include Groups are terms that must be present in the title, description or tags for a ' +
                 'content piece from this source in order for that piece to be eligible for a newsbrief. ' +
                 'Groups represent common grouping of terms that can be shared across sources.',
  },
  'source-config-included-matches': {
    description: 'If there are include terms associated with this source, this value defines how many must be ' +
                 'matched to allow an article into newsbriefs.  If omitted, matching a single include term will ' +
                 'allow any post.',
    fontSize: 'icon-12',
  },
  'source-config-included-tags': {
    description: 'Include tags are terms that must be present in the title, description or tags for a ' +
                 'content piece from this source in order for that piece to be eligible for a newsbrief.',
  },
  'source-config-is-active': {
    description: 'Enable/disable inclusion of content from this source within a newsbrief.',
  },
  'source-config-is-gated': {
    description: 'Specify whether this source requires login to view content.  If specified, email templates ' +
                 '<em>may</em> have visual distinction of this attribute.',
  },
  'source-config-max-per-newsbrief': {
    description: 'Maximum number of articles from this source that may be included in a newsbrief.  If omitted, ' +
                 'the global default will be used (consult your CSM for more information).',
    fontSize: 'icon-12',
  },
  'source-config-min-quality-score': {
    description: 'If specified, posts with specified minimum quality will be included.',
    fontSize: 'icon-12',
  },
  'source-config-min-tag-count': {
    description: 'If specified, content must generate at least the specified number of context tags to be eligible ' +
                 'for inclusion in a newsbrief.  If not specified, content will require at least 3 tags.  ' +
                 'This setting can help to exclude spam-like content from some sources.  If set to ' +
                 '0, all content can be included, regardless of tagging.',
    fontSize: 'icon-12',
  },
  'source-config-name': {
    description: 'Display name for this source in newsbriefs.',
    fontSize: 'icon-12',
  },
  'source-config-segment-attribute': {
    description: 'Specify the name of attribute associated with your subscriber list which is used for segementation.',
  },
  'source-config-segment-value': {
    description: 'Specify the segment for which this source can provide content.  If omitted, content is available ' +
                 'for all subscribers.  If specified, content is only available for subscribers who have ' +
                 'the corresponding value for the attribute (specified by the Segment Attribute field)',
  },
  'source-config-source-type': {
    description: 'Select the type of feed (RSS or Twitter) for this source URL.',
  },
  'source-config-subscription-type': {
    description: 'Select the type of content this source provides.',
    fontSize: 'icon-12',
  },
  'source-config-weighting': {
    description: 'Numeric value (0-10) indicating how important this source is relevant to other sources.  ' +
                 'Higher values indicate sources with higher relevance, and encourage recommendation engine ' +
                 'to choose content from this source.',
    fontSize: 'icon-12',
  },
  'source-name': {
    description: 'Enter a name for your source. ',
    fontSize: 'icon-12',
  },
  'source-url': {
    description: 'In order to update your source URL, please deactivate this current source and create a new source ' +
                 'with your new URL.',
    fontSize: 'icon-12',
  },
  'system-list-name': {
    description: 'Enter the name of the audience/list you want to integrate',
    fontSize: 'icon-12',
  },
  'system-password': {
    description: 'Enter your password for the system you are adding/updating credentials for.',
    fontSize: 'icon-12',
  },
  'system-username': {
    description: 'Enter your API Key or username for the system you are adding/updating credentials for.',
    fontSize: 'icon-12',
  },
}



// WEBPACK FOOTER //
// ./src/components/help/dictionary.ts